//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from '../title'
import Tab from '../from/tab'
import  Details  from "../monthly/details";
import { InsurStore,InsurMutations } from '../../store'

    export default {
        data() {
            return {
                show:false
            }
        },
        components: {
            InTitle,
            Tab,
            Details
        },
        props: {
            tabList:{
                type: Array,
                default: ()=>{
                    return []
                },
            },
        },
        computed: {
            insurance() {
                return InsurStore.insurance
            }
        },
        created(){
            this.tabHandler(0);
        },
        methods: {
            tabHandler(index) {
                // paid-支付, entrust-签约代扣
                // if(index == 0){  
                //     InsurMutations.setPay_period('month') //月缴
                //     InsurMutations.setPay_action('entrust') //签约代扣
                // }else{
                    InsurMutations.setPay_period('year') // 年缴 
                    InsurMutations.setPay_action('paid')    // paid
                // }
                this.$emit('tabClick',index)
            },
            details() {
                this.show = false;
                this.$nextTick(()=>{
                    this.show = true
                })
            },
        },
    }
